import RoleManagement from './RoleManagement.vue';

export default RoleManagement;
